import type { CommonColumns } from './common_columns';
import { commonColumns } from './common_columns';
import { companies } from './companies';

export type Organizations = CommonColumns & {
  resourceName: string;
  name: string;
  logoUrl: string;
  maximumNumberOfAdmins: string;
  salesAgency: string;
  ssoOnly: string;
  userInquiryFormUrl: string;
  userIpFiltered: string;
  adminIpFiltered: string;
  companyId: string;
  companyName: string;
  sysadminId: string;
  sysadminDisplayName: string;
  organizationAdminsCount: string;
  organizationUsersCount: string;
  controlInfo: string;
  department: string;
  departmentOne: string;
  departmentTwo: string;
  departmentThree: string;
  signInLock: string;
  forIndividuals: string;
};

// FIXME: refine
export const organizations: Readonly<Organizations> = {
  ...commonColumns,
  ...{
    resourceName: '組織',
    name: '組織名',
    logoUrl: 'ロゴ',
    maximumNumberOfAdmins: '組織管理者数上限',
    salesAgency: '販売代理店',
    ssoOnly: 'SSOでのみサインイン可',
    userInquiryFormUrl: '組織ユーザー専用問い合わせフォームURL',
    userIpFiltered: '組織ユーザーIPアドレスアクセス制限',
    adminIpFiltered: '組織管理者IPアドレスアクセス制限',
    companyId: `${companies.resourceName}${companies.id}`,
    companyName: companies.name,
    sysadminId: '組織担当者ID',
    sysadminDisplayName: '組織担当者名',
    organizationAdminsCount: '組織管理者数',
    organizationUsersCount: '組織ユーザー数',
    controlInfo: '制御情報',
    department: '部署',
    departmentOne: '部署1',
    departmentTwo: '部署2',
    departmentThree: '部署3',
    signInLock: 'サインインロック',
    forIndividuals: '個人向け組織',
  },
};

// FIXME: refine
export const organizationsSsoOnlysName = (
  ssoOnly: boolean | undefined
): string => {
  switch (ssoOnly) {
    case true:
      return '設定する';
    case false:
      return '設定しない';
    default:
      return '';
  }
};

// FIXME: refine
export const organizationsForIndividualsName = (
  forIndividuals: boolean | undefined
): string => {
  switch (forIndividuals) {
    case true:
      return '設定する';
    case false:
      return '設定しない';
    default:
      return '';
  }
};

// FIXME: refine
export const organizationsIpFilteredName = (
  ipFiltered: boolean | undefined
): string => {
  switch (ipFiltered) {
    case true:
      return 'あり';
    case false:
      return 'なし';
    default:
      return '';
  }
};
